import { useQuery } from "@tanstack/react-query";
import { ArrowRight, Workflow } from "lucide-react";
import { Link } from "react-router-dom";
import { EmptyState, ErrorState, LoadingState } from "../components/AsyncState";
import { apiRequest } from "../lib/api";
import { taskListSchema } from "../lib/schemas";
import { StateBadge } from "./OverviewPage";

export function TasksPage() {
  const query = useQuery({
    queryKey: ["tasks"],
    queryFn: () => apiRequest("/v1/admin/tasks?limit=250", taskListSchema),
    refetchInterval: 5_000
  });
  return (
    <main className="page">
      <div className="page-heading">
        <div>
          <p className="eyebrow">Durable execution</p>
          <h1>Tasks</h1>
        </div>
      </div>
      {query.isLoading && <LoadingState label="Loading task history" />}
      {query.error instanceof Error && <ErrorState error={query.error} />}
      {query.data?.data.length === 0 && (
        <EmptyState title="No tasks yet">
          <p>Create a task through the control plane to see its graph and timeline here.</p>
        </EmptyState>
      )}
      <div className="task-list">
        {query.data?.data.map((task) => (
          <Link className="task-row" to={`/tasks/${task.id}`} key={task.id}>
            <span className="task-icon">
              <Workflow size={17} />
            </span>
            <span className="task-main">
              <strong className="mono">{task.public_model}</strong>
              <small>{new Date(task.updated_at).toLocaleString()}</small>
            </span>
            <StateBadge state={task.status} />
            <span className="mono task-version">
              {task.nodes.completed}/{Object.values(task.nodes).reduce((a, b) => a + b, 0)} done
            </span>
            <ArrowRight size={16} />
          </Link>
        ))}
      </div>
    </main>
  );
}
